import { StampCardStatus as r } from "../../../../../../common/shared/loyalty/stampcard.js";
import { Adapter as a, getAdapter as t } from "../../../adapter.js";
import { StampProgrammeAdapter as m } from "../stampProgramme/stampProgramme.adapter.js";
import { StampAccountModel as o } from "./stampAccount.model.js";
class l extends a {
  adapt(e) {
    return new o({
      subStatus: e.sub_status ?? r.EXPIRED,
      maxBalance: e.max_balance,
      code: e.code,
      balance: e.balance,
      accBalance: e.acc_balance,
      expirationDate: e.expiration_date ? new Date(e.expiration_date * 1e3) : void 0,
      stampCard: t(m).adapt(e.stampcard),
      user: e.user ? {
        name: e.user.name,
        id: e.user.id,
        fullName: e.user.full_name
      } : void 0
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  l as StampAccountAdapter
};
//# sourceMappingURL=stampAccount.adapter.js.map
